import { createContext, useContext } from 'react'

/**
 * Lets a card inside an assistant message send a follow-up turn.
 *
 * Cards are rendered from a registry that hands them only `{ block, i }`, so
 * there was no way for one to reach the thread it lives in. Threading a
 * callback down every layer would touch a dozen components for one consumer.
 *
 * Optional by design: a card must still render in a story, a test, or any
 * surface with no thread behind it.
 */
export const ChatSendContext = createContext(null)

export function useChatSendOptional() {
  return useContext(ChatSendContext)
}
